import { render, staticRenderFns } from "./addOffender.vue?vue&type=template&id=aa9fe64c&scoped=true"
import script from "./addOffender.vue?vue&type=script&lang=js"
export * from "./addOffender.vue?vue&type=script&lang=js"
import style0 from "./addOffender.vue?vue&type=style&index=0&id=aa9fe64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9fe64c",
  null
  
)

export default component.exports